import { render, staticRenderFns } from "./calculateDot.vue?vue&type=template&id=54c71fe8&scoped=true&"
import script from "./calculateDot.vue?vue&type=script&lang=js&"
export * from "./calculateDot.vue?vue&type=script&lang=js&"
import style0 from "./calculateDot.vue?vue&type=style&index=0&id=54c71fe8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c71fe8",
  null
  
)

export default component.exports